import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { PromotionsBlock } from 'widgets/avia'
import {
  ExcursionsSearchForm,
  PopularDirectionsExcursions,
} from 'widgets/excursions'
import { HeaderTabs } from 'widgets/header-tabs'

import { findExcursionsStore } from 'entities/excursions/models/find-excursions/find-excursions-store'
import { listExcursionStore } from 'entities/excursions/models/list-excursions/list-excursions-state'

import { BottomNavigation } from 'shared/ui/bottom-navigation'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

const ExcursionsMainPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onSearch = async () => {
    navigate(RoutingPaths.excursion.search.path())
  }

  useEffect(() => {
    listExcursionStore.resetList()
    findExcursionsStore.onResetForm()
  }, [])

  return (
    <div className={clsx('bgGrey', s.container)}>
      <HeaderTabs module="excursion" />

      <Paper
        padding={[16]}
        radius={'28px'}
        className={s.paper}
      >
        <div className={s.box}>
          <p className={s.title}>{t('excursions.main_title')}</p>

          <p className={s.subTitle}>{t('excursions.main_subtitle')}</p>
        </div>

        <ExcursionsSearchForm
          onSearch={onSearch}
          type={'lightGrey'}
        />
      </Paper>

      <div className={s.promotions}>
        <PromotionsBlock type={'excursion'} />
      </div>

      <div className={s.popularDirection}>
        <PopularDirectionsExcursions />
      </div>

      <BottomNavigation activeId="home" />
    </div>
  )
})

export default ExcursionsMainPage
